import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { ListProtocolResponse } from '../../responses/risk-classification/list-protocol.response';
import { ListHealthGuidelineResponse } from '../../responses/risk-classification/list-health-guideline.response';
import { ReturnStruct } from 'src/app/shared/structs/return.struct';
import { GetHealthGuidelineResponse } from '../../responses/risk-classification/get-health-guideline.response';
import { HealthGuidelineRequest } from '../../requests/risk-classification/health-guideline.request';

@Injectable({
  providedIn: 'root'
})
export class HealthGuidelineService extends CommonService {

  constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }

  listGuideline(): Observable<ListHealthGuidelineResponse> {

    let uri = `HealthGuideline?`

    return this.httpClient.get<ListHealthGuidelineResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiRiskClassification) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

  getGuideline(idHealthGuideline: number): Observable<GetHealthGuidelineResponse> {
    let uri = `HealthGuideline/idHealthGuideline/${idHealthGuideline}`

    return this.httpClient.get<GetHealthGuidelineResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiRiskClassification) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

  updateGuideline(idHealthGuideline: number, healthGuidelineRequest: HealthGuidelineRequest): Observable<ReturnStruct> {
    let uri = `HealthGuideline/idHealthGuideline/${idHealthGuideline}`

    return this.httpClient.put<ReturnStruct>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiRiskClassification) + uri, healthGuidelineRequest, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

  craeteGuideline(healthGuidelineRequest: HealthGuidelineRequest): Observable<ReturnStruct> {
    let uri = `HealthGuideline`

    return this.httpClient.post<ReturnStruct>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiRiskClassification) + uri, healthGuidelineRequest, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

  deleteGuideline(idHealthGuideline: number): Observable<ReturnStruct> {
    let uri = `HealthGuideline/idHealthGuideline/${idHealthGuideline}`

    return this.httpClient.delete<ReturnStruct>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiRiskClassification) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }
}
